const adminMenuItems = [
  {
    path: "/admin/dashboard",
    title: "Dashboard",
  },
  {
    path: "/admin/candidates",
    title: "Candidates",
  },
  {
    path: "/admin/employers",
    title: "Employers",
  },
  {
    path: "/admin/jobposts",
    title: "Job Posts",
  },

  {
    path: "/admin/interviews",
    title: "Interviews",
  },
  {
    path: "/admin/placement-records",
    title: "Placements",
  },
  {
    path: "/admin/settings",
    title: "Settings",
  },
  // {
  //   path: "/admin/master/candidate-specialization",
  //   title: "Candidate Specializations",
  // },
  // {
  //   path: "/admin/master/employer-specialization",
  //   title: "Employer Specializations",
  // },
];

export default adminMenuItems;
